import React, { useState } from 'react';
import Header from './components/Header/Header';
import Heading from './components/Hero Section/heading';
import Promise from './components/Hero Section/promise';
import { CategoryButton, Categories } from './components/Category';
import BestSellers from '../../shared/components/ProductCardsA/BestSellers';
import FlashSale from './components/FlashSale/FlashSale';
import './components/Category/styles/category-content.css';
import CategoryBanner from './components/CategoryBanner/CategoryBanner';
import Footer from '@/shared/components/footer/footer';
import FeaturedProducts from './components/FeaturedProducts/FeaturedProducts';
import TrendingProducts from './components/TrendingProducts/TrendingProducts';
import './styles/indexMobile.css';
import HowItWorks from './components/HowItWorks/HowItWorks';
import NavigationMobileMenu from '@/shared/components/NavigationMobileMenu/NavigationMobileMenu';
import MobileFooter from '@/shared/components/MobileFooter/MobileFooter';
import FloatingCart from './components/Header/floatingcart';
import WhatsAppButton from '@/shared/components/WhatsAppButton/WhatsAppButton';
import AppDownloadModal from '@/shared/components/Appdownloadmoda/Appdownloadmoda';



const IndexPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'materials' | 'services'>('materials');
  return (
    <div className="index-page">
      <Header />
      <Heading/>
      <Promise/>

      <CategoryButton activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="category-content">
        <Categories activeTab={activeTab} />
        {/* <Services /> */}
      </div>
      <BestSellers />
      {/* <HomeServices /> */}
      {/* <ConstructionProducts /> */}
      {/* <BannerAd /> */}
      <FeaturedProducts />
      {/* <OfferBanner /> */}
      <TrendingProducts />
      <FlashSale />
      <CategoryBanner/>
      {/* <ServiceBanner/> */}
      {/* Mobile Footer - Only shows on mobile devices */}
      <div className="mobile-only">
        <MobileFooter/>
        <FloatingCart/>
        <NavigationMobileMenu/>
      </div>
      
      {/* Desktop/Tablet Footer - Only shows on larger screens */}
      <div className="desktop-only">
        <div className="how-it-works">
          <HowItWorks/>
        </div>
        <Footer/>
      </div>

      {/* WhatsApp Floating Button */}
      <WhatsAppButton 
        phoneNumber="917617610660" 
        message="Hello! I need some help with your products." 
      />
      
      {/* App Download Modal - Only shows on mobile devices */}
      <AppDownloadModal 
        onClose={() => console.log('Modal closed')}
        onDownload={() => {
          // Handle app download - redirect to app store or download page
          console.log('Download app clicked');
          // You can add redirect logic here
        }}
        onContinueWeb={() => console.log('Continue on web clicked')}
      />
    </div>
  );
};

export default IndexPage;
